/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import Category from './Category'
import i18n from '../../../../i18n'
import CategoryType from '@/model/dataLayer/api/dish/CategoryType'

const entity = {
  dishesId: {
    type: IKDataEntity.Types.Integer,
    displayName: 'product',
    formConfig: {
      requiredNew: false
    },
    header: false
  },

  ruleId: {
    header: false
  },

  name: {
    displayName: 'name'
  },
  dishesCategoryId: {
    displayName: 'dishesCategoryId',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: Category.getList,
        itemText: '_langsname'
      },
      editable: false
    },
    form: false

  },
  dishesCategoryTypeId: {
    displayName: 'TaxType',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => {
          const res = (await CategoryType.getList(true))
          res.forEach(it => {
            it.name = it._langsname
          })
          return res
        },
        itemText: 'name'
      },
      editable: false
    },
    form: false

  },

  enabled: {
    type: IKDataEntity.Types.Boolean,
    displayName: 'isActive'
  }

}

const config = {

  load: async function (filter) {
    const id = filter[0].ruleId
    return ((await hillo.get('DiscountRule.php?op=getDishesListByDiscountRuleId',
      {
        lang: i18n.locale,
        id
      }
    ))
      .content).map(d => {
      d.id = d.dishesId
      return d
    })
  },

  edit: async function (item) {
    return await hillo.post('DiscountRule.php?op=updateDishesDiscountRule',
      {
        dishesId: item.dishesId,
        discountRuleId: item.ruleId,
        enable: item.enabled ? 1 : 0
      })
  }

}

export default IKDataEntity.ModelFactory(entity, config)
